import { lazy } from 'react';
import Logout from '../../modules/Logout';
import JitsiMeetComponent from '../../shared/components/JitsiMeetComponent/JitsiMeetComponent';
import NotFoundComponent from '../../shared/components/NotFoundComponent';
import { authFeatureConstants, NOTREQUIRED } from '../../shared/constants/commonConstants';
import { RouteType } from '../../shared/models/route.models';
// import Finance from '../../modules/finance/Finance';
import Dashboard from '../../modules/Dashboard/Dashboard';
import ClaimsList from '../../modules/claimsView/ClaimsList';

// TODO : Role based route managament
const RoutesConfig: RouteType = {
  publicRoutes: [
    {
      path: '/logout',
      isPublic: true,
      component: Logout,
    },
    // {
    //   path: '/signup',
    //   isPublic: true,
    //   component: lazy((): any => import('../../modules/Auth/signUp/signUp')),
    // },
    {
      path: '/sl',
      isPublic: true,
      component: lazy((): any => import('../../modules/Auth/SSOLogin/SSOLogin')),
    },
    {
      path: '/resetpassword',
      isPublic: true,
      component: lazy((): any => import('../../modules/Auth/resetPassword/ResetPassword')),
    },
    {
      path: '/',
      isPublic: true,
      component: lazy((): any => import('../../modules/Auth/login/Auth')),
    },
    {
      path: '/google-auth',
      isPublic: true,
      component: lazy((): any => import('../../modules/Auth/GoogleSSO/GoogleRedirect')),
    },
    {
      path: '*',
      isPublic: false,
      component: NotFoundComponent,
    },
  ],
  privateRoutes: [
    {
      path: '/',
      isPublic: false,
      isExact: true,
      accessCheckKeyword: NOTREQUIRED,
      subRoutes: [
        {
          path: 'logout',
          isPublic: false,
          isExact: false,
          component: Logout,
          accessCheckKeyword: NOTREQUIRED,
        },
        {
          path: 'profile',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/hospital/Hospital')),
          accessCheckKeyword: authFeatureConstants.PROFILE,
        },
        {
          path: 'inventory',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/inventry/Inventry')),
          accessCheckKeyword: authFeatureConstants.INVENTORY,
        },
        {
          path: 'claims',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/crm/CRM')),
          accessCheckKeyword: authFeatureConstants.CLAIMS,
        },
        {
          path: 'reimbursement',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/reimbursement/Reimbursement')),
          accessCheckKeyword: authFeatureConstants.REIMBURSEMENT,
        },
        {
          path: 'grievance',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/grievance/Grievances')),
          accessCheckKeyword: authFeatureConstants.GRIEVANCE,
        },
        {
          path: 'abdm',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/abdmHIU/AbdmHIU')),
          accessCheckKeyword: authFeatureConstants.ABDM_HIU,
        },
        {
          path: 'resources',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/resources/Resources')),
          accessCheckKeyword: authFeatureConstants.RESOURCES,
        },
        {
          path: 'change-password',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/ChangePassword')),
          accessCheckKeyword: NOTREQUIRED,
        },
        // {
        //   path: 'finance',
        //   isPublic: false,
        //   isExact: false,
        //   component: Finance,
        //   accessCheckKeyword: authFeatureConstants.DASHBOARD,
        // },
        {
          path: 'metrics-board',
          isPublic: false,
          isExact: false,
          component: Dashboard,
          accessCheckKeyword: authFeatureConstants.METRICS_BOARD,
        },
        {
          path: 'jitsimeet/:id',
          isPublic: false,
          isExact: false,
          component: JitsiMeetComponent,
          accessCheckKeyword: NOTREQUIRED,
        },
        {
          path: 'reconciliation',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/reconciliation/Reconciliation')),
          accessCheckKeyword: authFeatureConstants.RECONCILIATION,
        },
         {
          path: 'reporting-and-analytics',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/reportingAndAnalytics/ReportingAndAnalytics')),
          accessCheckKeyword: authFeatureConstants.REPORT_ANALYTICS_MODULE,
        },
        {
          path: 'cost-of-care',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/costOfCare/costOfCare')),
          accessCheckKeyword: NOTREQUIRED,
        },
        {
          path: 'claimsView',
          isPublic: false,
          isExact: false,
          component: ClaimsList,
          accessCheckKeyword: authFeatureConstants.CLAIMS_DISPLAY,
        },
        {
          path: 'configurator',
          isPublic: false,
          isExact: false,
          component: lazy((): any => import('../../modules/configurator/configurator')),
          accessCheckKeyword: authFeatureConstants.CONFIGURATOR,
        },
        {
          path: '*',
          isPublic: false,
          component: NotFoundComponent,
          accessCheckKeyword: NOTREQUIRED,
        },
      ],
    },
  ],
};
export default RoutesConfig;
